import React from "react";

import { Modal } from "react-bootstrap";

import { commonErr } from "../common/errors";
import { verifyPhone } from "../../model/profile"

export default class VerifyPhone extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            err: commonErr.INNIT,
            errMsg: "",
            step: 0
        }
 
    }

    closeForm = () => {
        this.props.hideModal();
    }

    onVerifyBtnClick = () => {
        this.props.showVerifyPhoneOpt()
        this.props.hideModal()

    }

    retry = () => {
        this.setState({
            err: commonErr.INNIT,
            errMsg: "",
            step: 0
        });
    }

    finish = () => {
        this.setState({
            err: commonErr.INNIT,
            errMsg: "",
            step: 0
        });
        this.props.hideModal();
        this.props.getProfile();
    }

    render() {
        
        var content = <div className="modal-confirm-body">
                        <p className="font-14">Bạn cần xác minh số điện thoại mới có thể đăng kí xe.</p>
                        <div className="wrap-btn has-2-btn">
                            <a className="btn btn--m btn-primary" onClick={this.onVerifyBtnClick}>Xác minh</a>
                        </div>
                    </div>

        return <Modal
            show={this.props.show}
            onHide={this.finish}
            dialogClassName="modal-s modal-dialog modal-confirm"
        >
            <Modal.Header closeButton={true} closeLabel={""}>
                <h5>Xác minh số điện thoại</h5>
            </Modal.Header>
            <Modal.Body>
                {content}
            </Modal.Body>
        </Modal>
    }
}